// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__29XM2","title":"Images90_title__VpC4T","images":"Images90_images__1XprG"};